import React from 'react';
import { View } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import Separator from '../Separator/Separator';

import style from './style';

const Header = ({ title, price, dateUnit }) => {
  const theme = useTheme();
  return (
    <>
      <View style={style.container}>
        <VFText style={style.title(theme)} i18nKey={title} />
        <View style={style.titlePriceContainer}>
          <VFText style={style.price(theme)} i18nKey={price} />
          <VFText style={style.monthStyle(theme)} i18nKey={dateUnit} />
        </View>
      </View>
      <Separator theme={theme} />
    </>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  price: PropTypes.string,
  dateUnit: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default Header;
